<template>
    <div class="page">
        <header>
            <div class="header">
                <h2>收支明细</h2>
            </div>
        </header>
        <section class="count_info">
            <div class="balance">
                <p><b>￥ {{ (countInfo.balance / 100).toFixed(2) }}</b></p>
                <p>账户余额</p>
            </div>
            <div class="line"></div>
            <div class="items">
                <p>总收益 <br /><b>￥ {{ (countInfo.totalIncome / 100).toFixed(2) }}</b></p>
                <p>提现中 <br /><b>￥ {{ (countInfo.freezePrice / 100).toFixed(2) }}</b></p>
                <p>已提现 <br /><b>￥ {{ (countInfo.withdrawalAmount / 100).toFixed(2) }}</b></p>
                <p>已消费 <br /><b>￥ {{ (countInfo.consumptionAmount / 100).toFixed(2) }}</b></p>
            </div>
        </section>
        <section>
            <div class="input_box">
                <input type="text" v-model="queryParams.spuName" @change="query();" placeholder="请输入资产名称进行搜索" />
                <van-icon name="search" color="#969696" size="20" />
            </div>
            <div class="params">
                <div class="types">
                    <ul>
                        <li :class="{'active': !queryParams.tradeType}" @click="queryParams.tradeType = null; query()">全部</li>
                        <li :class="{'active': queryParams.tradeType == 1}" @click="queryParams.tradeType = 1; query()">收入</li>
                        <li :class="{'active': queryParams.tradeType == 2}" @click="queryParams.tradeType = 2; query()">支出</li>
                    </ul>
                </div>
                <div class="selectors">
                    <span @click="() => orderTypePickerRef.openPicker()">{{ queryParams.billType ?
                        queryParams.billTypeName : '账单类型' }} <van-icon name="arrow-down" /></span>
                    <span @click="() => timeRangePickerRef.openPicker()"> 交易时间 <van-icon name="arrow-down" /></span>
                </div>
            </div>

        </section>
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <ul class="list">
                <li v-for="item in list" :key="item.id">
                    <div class="name">
                        <p>订单编号： {{ item.orderNo }}</p>
                    </div>
                    <div class="line"></div>
                    <div class="content">
                        <div class="l">
                            <p>订单类型: <span>{{ ['购买资产', '账户提现', '账户充值', '销售资产'][item.billType] || '未知类型(' + item.billType + ')' }}</span></p>
                            <p>支付方式: <span>{{ item.payWay }}</span></p>
                            <p> {{ timeStampFormat(item.payTime) }}</p>
                        </div>
                        <div class="r">
                            <p>交易金额</p>
                            <p style="font-size: 20rem; color: #FF5733;" v-if="item.billType == 2"><b> + {{ item.amountDisplay }}</b></p>
                            <p style="font-size: 20rem; color: #2A82E4;" v-else><b> - {{ item.amountDisplay }}</b></p>
                        </div>
                    </div>

                </li>
            </ul>
        </van-list>
    </div>
    
    <order-type-picker ref="orderTypePickerRef"
        @confirm="d => { queryParams.billType = d[0].id; queryParams.billTypeName = d[0].name; query() }" />
    <time-range-picker ref="timeRangePickerRef"
        @confirm="d => { queryParams.payTime = d.startDate.getTime() + ',' + d.endDate.getTime(); query() }" />


</template>

<script setup>
import { http } from '@/request/http'
import { useStore } from 'vuex'
import { onMounted, reactive, ref, toRaw, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import { timeStampFormat } from '@/utils/util'
import orderTypePicker from '../../components/orderTypePicker.vue'
import timeRangePicker from '../../components/timeRangePicker.vue'

import { showNotify } from 'vant'

const orderTypePickerRef = ref(null)
const timeRangePickerRef = ref(null)

const router = useRouter()
const store = useStore()
const queryParams = reactive({
    billType: null, //账单类型
    billTypeName: null, 
    tradeType: null, 
    payTime: null, //支付时间
})
const pagination = reactive({
    pageNo: 1,
    pageSize: 10,
    total: 0
})
const countInfo = reactive({
    balance: 0,
    canWithdrawalAmount: 0,
    consumptionAmount: 0,
    freezePrice: 0,
    totalExpense: 0,
    totalIncome: 0,
    totalRecharge: 0,
    withdrawalAmount: 0,
})

const loading = ref(false)
const finished = ref(false)
const list = ref([])
const fetchList = () => {
    loading.value = true
    http.get('/app-api/trade/bill/detailed/page', {
        params: Object.assign({}, queryParams, pagination)
    }).then(res => {
        loading.value = false
        finished.value = res.list.length < pagination.pageSize
        pagination.total = res.total
        list.value = [...list.value, ...res.list]
    })
}
const onLoad = () => {
    pagination.pageNo++
    fetchList()
}
const query = () => {
    pagination.pageNo = 1
    list.value = []
    finished.value = false
    fetchList()
}


onMounted(() => {
    fetchList()
    http.get('app-api/pay/wallet/get').then(res => {
        Object.assign(countInfo, res)
    })
})

</script>

<style lang="scss" scoped>
@use '../common.scss';

.page {
    background-color: #F6F6F6;
    min-height: 100vh;

    header {
        padding: 15rem;
        background-color: #fff;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            img {
                height: 29rem;
            }
        }
    }
    section{
        margin: 5rem 0; background-color: #fff; padding: 15rem;
    }
    .count_info{
        .balance{
            padding-left: 15rem;
            p{color: #8B8B8B;}
            b{color: #FB0200; font-size: 20rem;}
        }
        .items{
            display: flex;
            p{
                width: 25%; color: #8B8B8B; text-align: center; font-size: 14rem; line-height: 30rem; border-right: 1rem solid #F6F6F6;
                b{color: #000; font-size: 16rem;}
            }
            p:last-child{
                border-right: none;
            }
        }
    }
    .params{
        display: flex; width: 100%;
        >div{
            width: 100%;
        }

        .types{
border-right: 1rem solid #D8D8D8; margin-right: 10rem;
        }
        .selectors{
            width: 100%; display: flex; justify-content: space-around;
        }
       ul{
            display: flex; width: 100%;
            li{width: 30%; height: 32rem; background-color: #F8F8F8; color: #8A8A8A; text-align: center; font-size: 14rem; line-height: 30rem;}
            .active{
                color: #000;
            }
       }
    }
    .list {
        padding-bottom: 50rem;

        li {
            background-color: #fff;
            width: 400rem;
            margin: 10rem auto;
            padding: 15rem;
            border-radius: 4rem;

            .name {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 14rem;

                span {
                    color: #0071BB;
                }
            }

            .line {
                width: 100%;
                height: 1rem;
                background-color: #F6F6F6;
                margin: 10rem 0;
            }

            .content {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .l {
                    width: 60%;

                    p {
                        height: 30rem;
                        line-height: 30rem;
                        color: #717171;
                        font-size: 14rem;

                        span {
                            color: #383838;
                        }
                    }
                }

                .r {
                    width: 40%;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;

                    p {
                        height: 30rem;
                        line-height: 30rem;
                        color: #717171;
                        font-size: 14rem;
                    }
                }
            }

            .time {
                font-size: 12rem;
                color: #717171;
                margin-top: 10rem;
                text-align: right;
            }
        }
    }
}
</style>